import { PageHeader } from "@/components/ui-bits";
import { useLang } from "@/lib/i18n";

export const Retourneren = () => {
  const { t } = useLang();
  return (
  <div className="px-6 sm:px-12 lg:px-20 pt-32 pb-24 max-w-4xl">
    <PageHeader
      eyebrow={t("retour.eyebrow")}
      title={<>Retourneren & <span className="italic normal-case text-gold">{t("retour.title2")}</span></>}
      sub={t("retour.sub")}
    />
    <div className="space-y-8 text-sm text-mist leading-relaxed">
      <div className="border border-gold/15 bg-ink p-6">
        <h2 className="font-serif text-xl text-cream mb-3">{t("retour.t1")}</h2>
        <p>{t("retour.b1")}</p>
      </div>
      <div className="border border-gold/15 bg-ink p-6">
        <h2 className="font-serif text-xl text-cream mb-3">{t("retour.t2")}</h2>
        <p>{t("retour.b2")}</p>
      </div>
      <div className="border border-gold/15 bg-ink p-6">
        <h2 className="font-serif text-xl text-cream mb-3">{t("retour.t3")}</h2>
        <p>{t("retour.b3")}</p>
      </div>
      <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-smoke">
        {t("retour.note")}
      </p>
    </div>
  </div>
  );
};

export default Retourneren;
